// import crypto from "crypto"
import CryptoJS from "crypto-js";
import {YEK_SEA} from "@/config/comm"

// let API_ENCRYPT_KEY = "2836e95fcd10e04b0069bb1ee659955b"
let API_ENCRYPT_WHITE = ["*.js", "*.css", "*.json", "*.html", "*.png", ".jpg", ".gif", '/processApi', '/biApi', '/authApi', '/userPermissions', '/oauth/token']
let API_ENCRYPT_ENABLE = true

const utils = {
    /**
     * 判断是否json字符串
     * @param { } str
     * @returns
     */
    isJSON: (str) => {
        if (typeof str == 'string') {
            try {
                JSON.parse(str);
                return true;
            } catch (e) {
                return false;
            }
        }
    },

    /**
     * 处理url参数加密
     * @param {*} url
     */
    buildUrl: (url) => {
        url = decodeURIComponent(url)
        let params = {}, tempArr = [];
        tempArr = url.split("?")[1].split("&");
        tempArr.forEach(v => {
            if (v.split("=")[0] && v.split("=")[0].indexOf('[]') >= 0) {
                //如果参数是数组 进行处理
                let key = v.split("=")[0].replace(/\[\]/, '')
                if (params[key]) {
                    params[key].push(v.split("=")[1])
                } else {
                    params[key] = [v.split("=")[1]]
                }
            } else {
                params[v.split("=")[0]] = v.split("=")[1]
            }
        });
        if (params) {
            params = utils.encryptParam(params);
            let path = url.split("?")[0] + "?";
            for (var k in params) {
                path += ((path.indexOf("=") != -1) ? "&" : "") + k + "=" + encodeURIComponent(params[k]);
            }
            url = path;
        }
        return url;
    },
    /**
     * 过滤白名单的地址
     * @param url
     * @returns
     */
    isExclude: (url) => {
        let flag = false
        for (let item of API_ENCRYPT_WHITE) {
            if (url.indexOf(item) > -1) {
                flag = true;
                break;
            }
            if (item.indexOf("*") > -1) {
                let isExist = false;
                let arr = item.split("*")
                for (let str of arr) {
                    if (!!str && url.indexOf(str) > -1) {
                        isExist = true
                    } else {
                        isExist = false
                        break
                    }
                }
                if (isExist)
                    flag = true
            }

        }
        return flag;
    },

    //AES 加密各参数
    encryptParam: (param) => {
        let obj = {};
        for (let prop in param) {
            if (param[prop]) {
                obj[prop] = utils._encryptText(param[prop].toString());
            } else {
                obj[prop] = '';
            }
        }
        return obj;
    },

    /**
     * 加密各参数
     * @param text
     */
    _encryptParam: (param) => {
        let obj = {};
        for (let prop in param) {
            if (param[prop] != null || param[prop] === 0) {
                if (param[prop].length === 0) {
                    obj[prop] = '';
                } else {
                    // if(Array.isArray(param[prop])) {
                    //     obj[prop] = utils._encryptText(JSON.stringify(param[prop]))
                    // } else if(typeof param[prop] == 'object') {
                    //     obj[prop] = utils._encryptText(JSON.stringify(param[prop]))
                    // } else {
                    obj[prop] = utils._encryptText(param[prop].toString());
                    // }
                }
            } else {
                obj[prop] = '';
            }
        }
        return obj;
    },
    /**
     * AES加密方法
     * @param text
     * @returns {string}
     */
    _encryptText: (text) => {
        let key = CryptoJS.enc.Utf8.parse(YEK_SEA);
        let readyText = CryptoJS.enc.Utf8.parse(text);
        let encryptedText = CryptoJS.AES.encrypt(readyText, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encryptedText.toString();
    },
    /**
     * AES 解密方法
     * @param text
     * @returns {*}
     */
    _decryptText: (text) => {
        let key = CryptoJS.enc.Utf8.parse(YEK_SEA);
        let decryptText = CryptoJS.AES.decrypt(text, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return CryptoJS.enc.Utf8.stringify(decryptText).toString();
    },

}


//请求发起前进入

export const encryptQuery = (config) => {
    if (!API_ENCRYPT_ENABLE) {
        return;
    }
    if (utils.isExclude(config.url) || config.url.includes("saveFile") || config.url.includes("get-calculate-data" ) ||  config.url.includes("uploadApi" )) {
        return;
    }
    if (config.url.indexOf("?") > -1 && utils.isExclude(config.url.split("?")[0])) {
        return;
    }


    if (config.method.toUpperCase() === "GET") {
        if (config.url.indexOf("?") > -1) {
            config.url = utils.buildUrl(config.url);
        } else if (config.params) {
            config.params = utils._encryptParam(config.params);
        }
    }

    if (config.method.toUpperCase() === "POST") {
        if (typeof config.data === "string") {
            config.data = utils._encryptText(config.data);
        }else{
            config.data = utils._encryptText(JSON.stringify(config.data));
        }
    }
}

